import { XCircle } from 'lucide-react';
import { countryLabel } from './countryLabel';

/** Generic failed-run banner. Caller supplies the friendly message via
 *  the ``message`` prop (each agent translates raw backend errors into
 *  its own user-facing copy). */
export function FailedBanner({
  country,
  message,
}: {
  country?: string | null;
  message: string;
}) {
  return (
    <div className="mb-[18px] py-[18px] px-[22px] bg-state-error-bg rounded-lg text-state-error-text">
      <div className="flex items-start gap-3">
        <XCircle className="size-6 text-state-error-accent shrink-0 mt-0.5" />
        <div className="flex-1">
          <h3 className="m-0 mb-1.5 text-[17px] font-bold">
            The analysis didn’t complete
            {country && (
              <span className="block mt-1 text-navy text-[24px] font-bold tracking-tight">
                {countryLabel(country)}
              </span>
            )}
          </h3>
          <p className="text-sm leading-[1.55] m-0">{message}</p>
        </div>
      </div>
    </div>
  );
}
